import {
  createReqConsts,
  createActions,
  createReqWatcher,
  makePaginationReducer,
} from '../../../utils/redux';
import { handleUpdateStatusSurveyInAppointmentDetails } from '../../../components/Healthboard/utils/handleUpdateStateWithCompleteSurvey';
import { handleUpdateStateWithAcceptedConsent } from '../../../components/Healthboard/utils/handleUpdateStateWithAcceptedConsent';
import { handleUpdateStateWithUploadDoc } from '../../../components/Healthboard/utils/handleUpdateStateWithUploadDoc';
import { handleUpdateStateWithDeleteDoc } from '../../../components/Healthboard/utils/handleUpdateStateWithDeleteDoc';
import { handleCheckin } from '../../../components/Healthboard/utils/handleCheckin';
import { findAndReplace } from '../../../utils/arrayModify';
import * as appointmentDetails from '../../appointmnents/appointment-details-req';
import { consts as SURVEY_COMPLETIONS } from '../../surveys/upcoming-survey-completions';
import { APPOINTMENT_DETAILS_TYPES } from '../appointment-details';
import { makeAppointmentListReqConfig } from './appointment-req-config';
import { consts as UPLOAD_DOCUMENT_CONST } from './upload-document-req';
import { consts as SIGN_CONSENT_APPOINTMENT } from './sign-appointment-consent-req';
import { consts as MANAGE_PENDING_APPOINTMENT } from './manage-pending-request';
import * as paymentVerification from './payment-verifications-req';
import { consts as EDIT_PAYMENT_CONST } from './edit-payment-req';
import { consts as DELETE_DOCUMENT } from './delete-document-req';
import { consts as CONFIRM_VISIT_BY_PATIENT } from './confirm-visit-by-patient-req';
import * as checkInReq from './check-in-appointment-req';
import * as cancelReq from './cancel-appointment-req';
import { consts as APPOINTMENT_ACCOUNT_FORM_PAYMENT } from '../../appointmnents/requests/appointment-account-form-payment-req';

const requestOptions = makeAppointmentListReqConfig([
  {
    type: 'payload.query',
    queryParameter: 'scope',
    value: 'upcoming_list',
  },
]);

export const consts = createReqConsts(
  'health-board',
  'upcoming-appointment-list-req',
  ['LOAD_MORE'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export const paginationConsts = createReqConsts(
  'health-board',
  'upcoming-appointment-list-lazy-load',
);
export const paginationActions = createActions(paginationConsts);
export const paginationWatcher = createReqWatcher(
  paginationConsts,
  paginationActions,
  requestOptions,
);

const reducer = makePaginationReducer({
  consts,
  paginationConsts,
  counterKey: 'appointmentsCount',
});

export default (state, action) => {
  switch (action.type) {
    case EDIT_PAYMENT_CONST.SUCCEED: {
      const target = state.list.find(({ id }) => action.payload.id === id);

      return {
        ...state,
        list: findAndReplace(state.list, {
          ...target,
          copay: action.payload.copay,
        }),
      };
    }

    case checkInReq.consts.SUCCEED: {
      return handleCheckin(state, action.payload);
    }

    case APPOINTMENT_DETAILS_TYPES.REPLACE_APPOINTMENT:
    case appointmentDetails.consts.SUCCEED: {
      return {
        ...state,
        list: findAndReplace(state.list, action.payload),
      };
    }

    case paymentVerification.consts.SUCCEED:
    case APPOINTMENT_ACCOUNT_FORM_PAYMENT.SUCCEED: {
      return {
        ...state,
        list: findAndReplace(state.list, action.payload.payable),
      };
    }

    case APPOINTMENT_DETAILS_TYPES.SLICE_UPCOMING_APPOINTMENT:
    case cancelReq.consts.SUCCEED: {
      const count = state.count - 1;

      return {
        ...state,
        count: count >= 0 ? count : 0,
        list: state.list.filter(({ id }) => id !== action.payload.id),
      };
    }

    case MANAGE_PENDING_APPOINTMENT.SUCCEED: {
      const target = state.list.find(({ id }) => action.payload.id === id);
      if (target) {
        return {
          ...state,
          list: findAndReplace(state.list, {
            ...target,
            status: action.payload.status,
          }),
        };
      }
      return {
        ...state,
      };
    }

    case SIGN_CONSENT_APPOINTMENT.SUCCEED: {
      return handleUpdateStateWithAcceptedConsent(state, action);
    }

    case UPLOAD_DOCUMENT_CONST.SUCCEED: {
      return handleUpdateStateWithUploadDoc(state, action);
    }

    case SURVEY_COMPLETIONS.SUCCEED: {
      return handleUpdateStatusSurveyInAppointmentDetails(state, action);
    }

    case DELETE_DOCUMENT.UPDATE: {
      return handleUpdateStateWithDeleteDoc(state, action);
    }

    case CONFIRM_VISIT_BY_PATIENT.SUCCEED: {
      return {
        ...state,
        list: findAndReplace(state.list, action.payload),
      };
    }

    default:
      return reducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/appointments-upcomming-req.js